var merge = require('webpack-merge')
var prodEnv = require('./prod.env')

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"'
})



//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = 339
// module chunks = 11